import styled from 'styled-components'
import { NotifySettingsPageProps, toggleDataListType } from 'src/pages/NotifySettingPage/index'
import { Container } from 'src/components/common/Container'
import {
  Noto_body1_b16,
  Noto_body2_b14,
  Noto_body2_m14,
  Noto_body2_r14,
} from 'src/styles/fonts/NotoSansKrFonts'
import { Typography } from 'src/components/common/Typography'
import { SmallDivider } from 'src/components/common/Divider'
import { Icon } from 'src/assets/svg/Icon'
import { mediaMaxWidth } from 'src/styles/mixin'
import RenderIf from 'src/components/common/RenderIf'
import { useChannel } from 'src/provider/ChannelContextProvider'

const NotifySettingsPageView = ({
  toggleDataList,
  naviAppSystemNotifyPage,
  onToggleChangeHandler,
}: NotifySettingsPageProps) => {
  const { web } = useChannel()
  return (
    <S.NotifyContainer $option="flex_column">
      {toggleDataList?.map((ele: toggleDataListType) => (
        <Container $option="flex_column" key={ele?.type}>
          <Typography $fontStyle={Noto_body2_m14} $color="var(--black-50)">
            {ele?.text}
          </Typography>
          <S.NotifyItemsWrap $option="flex_row_space_between">
            <Typography $fontStyle={Noto_body1_b16}>{ele?.text}</Typography>
            <S.ToggleWrap $option="flex_row" $column_gap="10px" $width="fit-content">
              <Typography $fontStyle={Noto_body2_r14} $color="var(--black-70)">
                {ele?.status ? '켜짐' : '꺼짐'}
              </Typography>
              <S.ToggleSwitch onClick={() => onToggleChangeHandler(ele?.type)} value={ele?.status}>
                <S.ActionCircle value={ele?.status} />
              </S.ToggleSwitch>
            </S.ToggleWrap>
          </S.NotifyItemsWrap>
        </Container>
      ))}
      <SmallDivider />
      <S.NotifySettingWrap>
        <RenderIf when={!web}>
          <Typography $fontStyle={Noto_body2_r14} $color="var(--black-50)">
            알림을 받으려면 앱 설정에서 알림을 허용해야 합니다.
          </Typography>
        </RenderIf>
        <RenderIf when={!web}>
          <S.AppSettingNavWrap $option="flex_row" $column_gap="2px">
            <Typography
              $fontStyle={Noto_body2_b14}
              $color="var(--black-50)"
              onClick={naviAppSystemNotifyPage}
            >
              앱 설정 가기
            </Typography>
            <Icon.Arrow size="16" rotate="right" color="var(--black-50)" />
          </S.AppSettingNavWrap>
        </RenderIf>
      </S.NotifySettingWrap>
    </S.NotifyContainer>
  )
}
export default NotifySettingsPageView

const S = {
  NotifyContainer: styled(Container)`
    flex: 1;
    padding: 30px 20px;
    gap: 20px;
  `,
  NotifyItemsWrap: styled(Container)`
    border-radius: 12px;
    background-color: var(--black-4);
    padding: 16px 20px;
    align-items: center;
    margin-top: 10px;
  `,
  AppSettingNavWrap: styled(Container)`
    align-items: center;
    justify-content: right;
    position: relative;
    ${mediaMaxWidth('510')} {
      width: 100%;
    }
    width: fit-content;
  `,
  ToggleWrap: styled(Container)`
    align-items: center;
  `,
  ToggleSwitch: styled.section<{ value: boolean }>`
    position: relative;
    width: 40px;
    height: 22px;
    padding: 2px;
    display: flex;
    border-radius: 100px;
    align-items: center;
    background-color: ${({ value }) => (value ? 'var(--brand-50)' : 'var(--black-30)')};
  `,

  NotifySettingWrap: styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 4px;
  `,
  ActionCircle: styled.span<{ value: boolean }>`
    line-height: 20px;
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 100px;
    background-color: var(--white);
    transition: all 0.3s ease-in-out;
    z-index: 1;
    ${({ value }) => (value ? 'transform: translateX(18px)' : 'transform: translateX(0px)')}
  `,
}
